module.exports = "<div class=\"carousel-item Wallop-item\" [attr.data-text]=\"title\">\n\t<div *ngIf=\"getVideo() == null\">\n\t\t<div class=\"image-wrapper\" [ngStyle]=\"{'background-image': getImageUrl()}\">\n\n\t\t</div>\n\t</div>\n\t<div *ngIf=\"getVideo() != null\" class=\"image-wrapper\" style=\"padding-top: 10%\">\n\t\t<video style=\"width: inherit\" controls autoplay muted playsinline loop poster=\"{{getImageUrl()}}\">\n\t\t\t<source src=\"{{getVideo()}}\">\n\t\t</video>\n\t</div>\n</div>"


/*****************
 ** WEBPACK FOOTER
 ** ./app/service-modules/carousel-item/carousel-item.html
 ** module id = 1003
 ** module chunks = 1
 **/